<template>
  <footer class="py-5 footer">
    <div class="container">
      <div class="row">
        <div class="mx-auto mt-1 text-center col-8">
          <p class="mb-0 text-secondary">
            Copyright &copy; {{ new Date().getFullYear() }} desarrollado por
            Data 15-22 S.A.S. v1.0.9
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'app-footer',
};
</script>
